import { Trans } from "@lingui/react/macro"
import { Button, Group, Modal, Text } from "@mantine/core"
import { formatClock } from "../../../lib/format-date"
import type { IProps } from "./interfaces"

/**
 * Pause-timeout modal — pops 5 minutes after the user paused recording, and
 * counts down a further 5 minutes before the recording auto-finalizes. The
 * smart wrapper (usePauseResume) owns the timers and `opened` state.
 */
export const PauseTimeoutModal = ({
  opened,
  remainingSeconds,
  onKeepPaused,
  onFinalize,
}: IProps): React.JSX.Element => {
  return (
    <Modal
      opened={opened}
      onClose={onKeepPaused}
      title={<Trans>Still recording?</Trans>}
      centered
      withCloseButton={false}
    >
      <Text size="sm" c="dimmed" mb="md">
        <Trans>
          This recording has been paused for 5 minutes. It will auto-finalize in {formatClock(remainingSeconds)} unless
          you keep it paused.
        </Trans>
      </Text>
      <Group justify="flex-end">
        <Button variant="subtle" color="danger" onClick={onFinalize}>
          <Trans>Finalize now</Trans>
        </Button>
        <Button color="brand" onClick={onKeepPaused}>
          <Trans>Keep paused</Trans>
        </Button>
      </Group>
    </Modal>
  )
}
